import React from 'react';
import { Button, makeStyles, Avatar } from '@material-ui/core';
import { IWhatsAppButton } from './types';
import {
    WHATSAPP_COLOR,
    WHATSAPP_HOVER_COLOR,
} from 'src/constants/variants/variants';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    whatsAppIcon: {
        width: 32,
        height: 32,
    },
    button: {
        backgroundColor: WHATSAPP_COLOR,
        height: 60,
        color: 'white',
        '&:hover': {
            backgroundColor: WHATSAPP_HOVER_COLOR,
        },
    },
}));

export const WhatsAppButton = ({ ...props }: IWhatsAppButton) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Button
            variant="contained"
            size="large"
            fullWidth
            className={classes.button}
            startIcon={
                <Avatar
                    alt="wsp-icon"
                    src={'/static/logos/whatsapp.png'}
                    className={classes.whatsAppIcon}
                />
            }
            {...props}
        >
            {t('Leads.SendWsp')}
        </Button>
    );
};
